/**
 * P8-04: 统一埋点入口
 * 封装 tracker / errorReporter / performance，对外暴露单一 trackEvent API。
 */
import { track, initTracker, getSessionId } from './tracker';
import { initErrorReporting, reportReactError, reportCustomError } from './errorReporter';
import { initPerformanceMonitoring, ScenePerformanceMonitor } from './performance';

export { track as trackEvent, initTracker, getSessionId };
export { initErrorReporting, reportReactError, reportCustomError };
export { initPerformanceMonitoring, ScenePerformanceMonitor };

/**
 * 一键初始化全部监控子系统
 * 应在应用启动时调用（main.tsx 或 App.tsx）
 */
export function initAnalytics(prodOnly: boolean = false) {
  const isProd = import.meta.env.PROD;
  if (isProd || !prodOnly) {
    initPerformanceMonitoring();
  }
  initErrorReporting();
  initTracker();
}
